export const yesNo = [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }];

export const BUBBLE_VISIBLE_IN = [0, 1, 3];
export const FORM_STEPS = [
  "Labels.ClientProfile",
  "Labels.ClientDocuments",
  "Labels.ClientCeoRep",
  "Labels.PoliticallyExposedPerson",
  "Labels.ClientBeneficiaries",
  "Labels.CompanyActivity",
  "Labels.ClientPlanTurn",
  "Labels.OtherInformation"
];
export const TOTAL_STEPS = FORM_STEPS.length;
